<div class="content-header">
    <h2>Promoción electrónica</h2>
</div>

<form [formGroup]="formulario">
    <div class="form-section">
        <div class="form-grid">
            <div class="form-group">
                <label for="tipo-filtro">Estado</label>
                <!-- <select id="tipo-filtro" formControlName="tipoFiltro">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let tipoFiltro of tiposFiltros" [value]="tipoFiltro.Id">{{ tipoFiltro.Descripcion }}</option>
                </select> -->
                <ng-select placeholder="Seleccione una opción" id="tipo-filtro" formControlName="tipoFiltro">
                    @for (tipoFiltro of tiposFiltros; track tipoFiltro.Id) {
                    <ng-option [value]="tipoFiltro.Id">
                        <span [title]="tipoFiltro.Descripcion">{{tipoFiltro.Descripcion}}</span>
                    </ng-option>
                    }
                </ng-select>

            </div>
            <div class="form-group">
                <label for="tipo-organo">Tipo de Órgano</label>
                <!-- <select id="tipo-organo" formControlName="tipoOrgano">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let circuitosTipoOrganismo of circuitosTipoOrganismo"
                        [value]="circuitosTipoOrganismo.Id">{{ circuitosTipoOrganismo.Descripcion }}</option>
                </select> -->
                <ng-select placeholder="Seleccione una opción" id="tipo-organo" formControlName="tipoOrgano">
                    @for(circuitosTipoOrganismo of circuitosTipoOrganismo; track circuitosTipoOrganismo.Id) {
                    <ng-option [value]="circuitosTipoOrganismo.Id">
                        <span [title]="circuitosTipoOrganismo.Descripcion">{{circuitosTipoOrganismo.Descripcion}}</span>
                    </ng-option>
                    }

                </ng-select>
            </div>
            <div class="form-group">
                <label for="materia">Materia</label>
              <!--   <select id="materia" formControlName="materiaTipo">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let materiaOrganismo of materiasTipoOrganismo" [value]="materiaOrganismo.Id">{{
                        materiaOrganismo.Descripcion }}</option>
                </select> -->
                 <ng-select placeholder="Seleccione una opción" id="materia" formControlName="materiaTipo">
                     @for(materiaOrganismo of materiasTipoOrganismo; track materiaOrganismo.Id) {
                    <ng-option [value]="materiaOrganismo.Id">
                        <span [title]="materiaOrganismo.Descripcion">{{materiaOrganismo.Descripcion}}</span>
                    </ng-option>
                    }
                </ng-select>
            </div>
            <div class="form-group">
                <label for="organos-jurisdiccionales">Órgano</label>
               <!--  <select id="organos-jurisdiccionales" formControlName="organoJurisdiccional">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let organismo of organismoTipoCircuito" [value]="organismo.Id">{{
                        organismo.Descripcion }}</option>
                </select> -->
                 <ng-select placeholder="Seleccione una opción" id="organos-jurisdiccionales" formControlName="organoJurisdiccional">
                     @for(organismo of organismoTipoCircuito; track organismo.Id) {
                    <ng-option [value]="organismo.Id">
                        <span [title]="organismo.Descripcion">{{organismo.Descripcion}}</span>
                    </ng-option>
                    }
                </ng-select>
            </div>
            <div class="form-group">
                <label for="tipo-asunto">Tipo de asunto</label>
                <!-- <select id="tipo-asunto" formControlName="tiposAsunto">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let tipoAsuntoOrganismo of tiposAsuntoOrganismo" [value]="tipoAsuntoOrganismo.Id">{{
                        tipoAsuntoOrganismo.Descripcion }}</option>
                </select> -->
                <ng-select placeholder="Seleccione una opción"  id="tipo-asunto" formControlName="tiposAsunto">
                   @for(tipoAsuntoOrganismo of tiposAsuntoOrganismo; track tipoAsuntoOrganismo.Id) {
                    <ng-option [value]="tipoAsuntoOrganismo.Id">
                        <span [title]="tipoAsuntoOrganismo.Descripcion">{{tipoAsuntoOrganismo.Descripcion}}</span>
                    </ng-option>
                    }
                </ng-select>
            </div>
            @if(mostrarTipoProcedimiento){
            <div class="form-group">
                <label for="tipo-procedimiento">Tipo procedimiento</label>
                <!-- <select id="tipo-procedimiento" formControlName="tipoProcedimiento">
                    <option value="">Seleccionar</option>
                    <option *ngFor="let tipoProcedimiento of tiposProcedimientos" [value]="tipoProcedimiento.Id">{{
                        tipoProcedimiento.Descripcion }}</option>
                </select> -->
                <ng-select placeholder="Seleccione una opción"  id="tipo-procedimiento" formControlName="tipoProcedimiento">
                 @for(tipoProcedimiento of tiposProcedimientos; track tipoProcedimiento.Id) {
                    <ng-option [value]="tipoProcedimiento.Id">
                        <span [title]="tipoProcedimiento.Descripcion">{{tipoProcedimiento.Descripcion}}</span>
                    </ng-option>
                    }
                </ng-select>
            </div>
        }

        </div>

        <div class="form-actions">
            <div class="form-group input-with-button formVert">
                <label for="numero-expediente">Numero de Expediente:</label>
                <input type="text" id="numero-expediente" formControlName="numeroExpediente">
                <button class="btn-search-promotion" (click)="buscarExpediente()">Buscar</button>
            </div>
        </div>
        <br><br>
     <!-- ART - Se comenta para la primera etapa, se habilitará en próximas etapas cuando se integre con el expediente electrónico -->
      <!--   <div class="form-grid">
            <div class="form-group">
                <label for="numero-expedienteOIJ">Numero de Expediente de Autoridad:</label>
                <input type="text" id="numero-expedienteOIJ" formControlName="numeroExpedienteOIJ">
            </div>

            <div class="form-group">
                <label for="existe-EE">Existe Expediente Electronico de Autoridad:</label>
                <input type="checkbox" id="existe-EE" formControlName="existeEE">
            </div>

            <div class="form-group">
                <label for="url-EE">Url Expediente Electronico de Autoridad:</label>
                <input type="text" id="url-EE" formControlName="urlEE">
            </div>
        </div> -->


        <div>
            <oaj-alert-itx></oaj-alert-itx>
        </div>

    </div>

    <div class="document-upload-section">
        <h3>Adjuntar documento:</h3>
        <p class="formats-info">Formatos válidos de archivo: {{sFormatos}}</p>

        <div class="aviso-frame">
            <p>
                Al ingresar el documento, verificar que el nombre del archivo no cuente con signos de puntuación,
                admiración
                o caracteres especiales como apóstrofes, guiones, etc.
            </p>
            <p>
                Nota: El tamaño límite de los archivos debe ser 40 MB por documento, mismos que en su conjunto no deberán de exceder de 360 MB por envío.
            </p>
        </div>
        <div class="row mt-3 justify-content-end">
            <div class="col-12 col-sm-auto">
                <!-- <button class="btn btn-file" (click)="cargaArchivo()" [disabled]="!expedienteEncontrado">Seleccionar
                    archivos </button> -->
                <button class="btn btn-file" (click)="openWindowFirma()" [disabled]="!expedienteEncontrado">Seleccionar
                    archivos </button>
                <!-- <span class="btn btn-file">
                    Seleccionar archivos <input id="ArchivosPromocion" name="ArchivosPromocion" multiple="" type="file"
                        accept=".doc,.docx,.pdf" [disabled]="!expedienteEncontrado">
                </span> -->
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-auto">
                <div class="center">
                    <oaj-loader-itx [loading]="isLoadingFile" [sMensaje]="sMensajeLoad" #loaderSpinner></oaj-loader-itx>
                </div>
                @if(!isLoadingFile){
                <oaj-lista-archivos-itx class="form-control" [archivos]="lstDocumentos" [verBorrar]="true"
                    (BorraDoc)="EliminarDocumentosPantalla($event)" [verPrevisualizar]="true" [OcultaSystemName]="true" [downloagOrg]="true">
                </oaj-lista-archivos-itx>
                }
            </div>
        </div>

        <div class="row mt-3 justify-content-end"></div>
        <hr>
        <div class="row mt-3 justify-content-end">
            <!-- <button class="btn btn-envio" (click)="getAcuse(11)">ACUSE </button> -->
            <div class="col-12 col-sm-auto">
                <button type="submit" class="btn btn-envio" [disabled]="loading" (click)="EnviarPromocion()">
                    @if(!loading){
                    <span>Enviar Promoción</span>
                    }
                    @else{
                    <span class="d-flex align-items-center justify-content-center">
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Enviando...
                    </span>
                    }
                </button>
            </div>

        </div>

    </div>
</form>